import { useMediaQuery } from '@hooks/useMediaQuery';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import { Accordion } from '@stories/Components/Misc/Accordion/Accordion';
import { useScroll } from 'framer-motion';
import * as React from 'react';
import S from './FAQs.styles';
import { linkAria } from '@helpers/utils';
const Section = (props) => {
    const ref = React.useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ['end end', '-240px start'],
    });
    React.useEffect(() => {
        if (!props.enableScroll) {
            return;
        }
        scrollYProgress.onChange(() => {
            props.setActiveSectionId(props.id);
        });
    }, [props.enableScroll, scrollYProgress]);
    return (React.createElement(S.Section, { id: props.id, ref: ref },
        props.showTitle && React.createElement(S.SectionTitle, null, props.title),
        React.createElement(Accordion, { initialId: props.initialId ?? '' }, props.items &&
            props.items.map((item) => (React.createElement(Accordion.Item, { key: item.id, id: item.id, title: item.question },
                React.createElement(S.AccordionAnswer, null,
                    React.createElement("div", { dangerouslySetInnerHTML: { __html: item.answer } }),
                    item.cta && item.cta.url && item.cta.text && (React.createElement(LinkButton, { "aria-label": linkAria(item.cta.text ?? '', item.cta.target, props.translations && props.translations['lcci.link.newtab']), href: item.cta.url, target: item.cta.target ?? '_self', buttonType: "orange-solid" }, item.cta.text)))))))));
};
const FAQs = (props) => {
    const isMobile = useMediaQuery('(max-width: 1024px)');
    const [activeSectionId, setActiveSectionId] = React.useState(props.navigation ? props.navigation[0].anchorId : '');
    return (React.createElement(S.Container, { id: props.anchorId, spacing: "padding" },
        props.sections && props.sections.length > 1 ? React.createElement(S.ShapeWrapper, null) : null,
        React.createElement(S.Inner, null,
            React.createElement(S.Aside, null,
                React.createElement(S.StickyContainer, null,
                    React.createElement(S.Subtitle, null, props.subtitle),
                    React.createElement(S.Title, { ...(props.titleType && props.titleType === 'h1' ? { as: 'h1' } : {}) }, props.title),
                    props.cta && props.cta.url && props.cta.text && (React.createElement(LinkButton, { "aria-label": linkAria(props.cta.text ?? '', props.cta.target, props.translations && props.translations['lcci.link.newtab']), href: props.cta.url, target: props.cta.target ?? '_self', buttonType: "blue-solid" }, props.cta.text)),
                    props.navigation && props.showNavigation && (React.createElement(S.SideNavigation, null,
                        React.createElement(S.List, null, props.navigation.map((li) => (React.createElement(S.Item, { key: li.text, "aria-current": li.anchorId === activeSectionId },
                            React.createElement(S.Link, { href: `#${li.anchorId}` }, li.text))))))))),
            React.createElement(S.ContentWrapper, null, props.sections &&
                props.sections.map((section, index) => {
                    const sectionId = props.navigation
                        ? props.navigation[index].anchorId
                        : `section-${index}`;
                    return (React.createElement(Section, { key: sectionId, id: sectionId, ...section, showTitle: props.sections.length > 1, initialId: index === 0 ? section.items[0].id : '', setActiveSectionId: setActiveSectionId, enableScroll: !isMobile && props.showNavigation, translations: props.translations }));
                })))));
};
export default FAQs;
